<template>
  <v-container>
    <sub-navigation></sub-navigation>

    <SporiciProgramDialog v-if="sporici_program_id!=null" :id="sporici_program_id.toString()" @close="sporici_program_id=null;" :moje="true"></SporiciProgramDialog>
    <VytvoritSporiciProgramDialog v-if="vytvoritSporiciProgram" :klient="me.uid" @close="vytvoritSporiciProgram=false;" @created="createdSporiciProgram"></VytvoritSporiciProgramDialog>

    <v-layout row wrap class="justify-end">
      <!-- <v-flex xs6>
        <h1 class="h2 mb-30">Postupné nákupy</h1>
      </v-flex> -->
      <!-- <v-flex xs6>
        <v-btn color="orange" depressed dark class="right ma-0"><v-icon class="mr-2">add</v-icon>Nový nákup</v-btn>
      </v-flex> -->
      <v-flex v-if="me.spolupracovnik" shrink>
        <v-btn color="orange" outline class="ma-0 mr-4 btn-aside" :class="{'mb-2': $vuetify.breakpoint.smAndDown}" @click="createClick">Vytvořit postupný nákup</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :loading="loadingTable"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum_sjednani | formatSimpleDate }}</td>
            <td>{{ props.item.nazev_sporeni }}</td>
            <td>{{ props.item.cilova_castka | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td>{{ props.item.mesicni_platba | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td>{{ props.item.nasporena_castka | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td>
              <span v-if="props.item.stav_sporeni=='probiha'">Bežící</span>
              <span v-else-if="props.item.stav_sporeni=='dokonceno'">Dokončeno</span>
              <span v-else-if="props.item.stav_sporeni=='zruseno'">Zrušeno</span>
            </td>
            <td class="text-xs-right">
              <v-btn color="orange" @click="detailClick(props.item.id)" dark class="elevation-0 ma-0 bold"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import SporiciProgramDialog from '../components/SporiciProgramDialog'
  import Base from '../Base'
  import VytvoritSporiciProgramDialog from "@/components/VytvoritSporiciProgramDialog";
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        dialogDetail: false,
        vytvoritSporiciProgram: false,
        headers: [
          { text: 'Datum sjednání', value: 'datum_sjednani', sortable: false },
          { text: 'Název spořeni', value: 'nazev_sporeni', sortable: false },
          { text: 'Cílová částka', value: 'cilova_castka', sortable: false },
          { text: 'Měsíční platba', value: 'mesicni_platba', sortable: false },
          { text: 'Naspořená částka', value: 'nasporena_castka', sortable: false },
          { text: 'Stav', value: 'stav_sporeni', sortable: false },
          { text: '', value: null, sortable: false, align: "right" }
        ],
        items: [],
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        },
        editMode: false,
        sporici_program_id: null,
        loadingTable: false
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    props: {
      id: String,
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.load();
    		},
    		deep: true
    	},
    },
    mounted () {
      this.load(() => {
        if (typeof this.$props.id !== "undefined" && this.$props.id.length > 0)
          this.detailClick(this.$props.id);
      });
    },
    methods: {
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("nakupy/sporici-programy/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
          if (typeof f === "function")
            f();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      detailClick (v) {
        this.sporici_program_id = v;
      },
      createdSporiciProgram () {
        this.vytvoritSporiciProgram = false;
        this.load();
      },
      createClick() {
        this.vytvoritSporiciProgram = true;
      }
    },
    components: {
      SporiciProgramDialog, VytvoritSporiciProgramDialog
    }
  }
</script>
